"use client";
import SideRailContent from "./renderSideRailContent";
import { SideRailComponentProps, ComponentListProps } from "../types";
import { extractComponentNames } from "@/utils/getSortedComponentsBySectionOrder";

interface Props {
  sideRailMobileHeaderComponents: SideRailComponentProps[] | undefined;
  sideRailMobileBodyComponents: SideRailComponentProps[] | undefined;
}

export default function MobileContent({
  componentList,
  sideRailMobileHeaderComponents,
  sideRailMobileBodyComponents,
}: Props & ComponentListProps) {
  const defaultSideRailMobileHeaderComponents: SideRailComponentProps[] = [
    { component: "sideRailTitle" },
    { component: "videoPlayer" },
    { component: "productTitle" },
    { component: "rating" },
  ];

  const headerWithoutCallout = (
    sideRailMobileHeaderComponents ?? defaultSideRailMobileHeaderComponents
  ).filter((c) => c.component !== "heroAccentCallout");
  const descIdx = headerWithoutCallout.findIndex(
    (c) => c.component === "courseDescription",
  );
  const headerComponents =
    descIdx === -1
      ? headerWithoutCallout
      : [
          ...headerWithoutCallout.slice(0, descIdx + 1),
          { component: "heroAccentCallout" },
          ...headerWithoutCallout.slice(descIdx + 1),
        ];

  const defaultSideRailMobileBodyComponents: SideRailComponentProps[] = [
    { component: "pricing" },
    { component: "ctaButton" },
    { component: "programCourses" },
    { component: "bulletList" },
  ];
  const bodyComponents =
    sideRailMobileBodyComponents ?? defaultSideRailMobileBodyComponents;
  return (
    <div className="flex flex-col gap-4 w-full">
      <SideRailContent
        components={componentList}
        headerComponentsOrder={extractComponentNames(headerComponents)}
        bodyComponentsOrder={extractComponentNames(bodyComponents)}
      />
    </div>
  );
}
